import { render, staticRenderFns } from "./CreazioneTeam.vue?vue&type=template&id=11c87e3d&scoped=true&"
import script from "./CreazioneTeam.vue?vue&type=script&lang=js&"
export * from "./CreazioneTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c87e3d",
  null
  
)

export default component.exports